import { Zap, Handshake, MapPin } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const badges: { icon: LucideIcon; text: string }[] = [
  { icon: Zap, text: "Seamless process" },
  { icon: Handshake, text: "Reliable fulfilment" },
  { icon: MapPin, text: "Transparent tracking" },
];

const TrustBadges = () => {
  return (
    <div className="flex justify-center gap-6 lg:gap-12 py-6">
      {badges.map((badge, index) => (
        <div
          key={badge.text}
          className={`trust-badge animate-fade-up-delay-${index + 1}`}
        >
          <badge.icon className="w-6 h-6 lg:w-8 lg:h-8 text-primary mb-1" />
          <span className="text-xs lg:text-sm font-medium text-muted-foreground">
            {badge.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
